module.exports = __webpack_public_path__ + "img/CM4SF.64969e26.png";